import { VisuallyHiddenProps } from '@radix-ui/react-visually-hidden';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

/* This component is for screen reader use only, 
    and meant for labels that are hidden from the screen view */

const SROnly = (props: VisuallyHiddenProps) => {
  return <VisuallyHidden.Root {...props}>{props.children}</VisuallyHidden.Root>;
};

export default SROnly;
